import { render, staticRenderFns } from "./AdvancedSettings.vue?vue&type=template&id=461734b4"
import script from "./AdvancedSettings.vue?vue&type=script&lang=js"
export * from "./AdvancedSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports